import script from "./security-event-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./security-event-list.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__